import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { axiosSafeRequest } from "../axiosSafeRequest";
import { MachineInfo, MachineStats } from "../types";

type MachinesApiResponse = AxiosResponse<MachineInfo[]>;
type StatsApiResponse = AxiosResponse<MachineStats>;

/**
 * Get all activated machines for the current user's licence key.
 *
 * @returns An HTTP response with the list of machines.
 */
export const apiMachineMachinesGet = async (): Promise<MachinesApiResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.get(`/machine/machines`));
}

/**
 * Get dashboard statistics for the current user's licence key.
 *
 * @returns An HTTP response with the dashboard statistics.
 */
export const apiMachineStatsGet = async (): Promise<StatsApiResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.get(`/machine/stats`));
}
